import { render, staticRenderFns } from "./editSchool.vue?vue&type=template&id=b1e0e3ac&scoped=true&"
import script from "./editSchool.vue?vue&type=script&lang=ts&"
export * from "./editSchool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e0e3ac",
  null
  
)

export default component.exports